var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRadioboxBlankIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 22 22",
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  transform: "translate(1 1)",
  stroke: "#333",
  fill: "none",
  fillRule: "evenodd"
})));
export default SvgRadioboxBlankIconcom;